// ----------------------------------------------------------------------

const ptBr = {
  videoLibrary: {
    noFolder: `Vídeos sem pasta`,
    status: {
      ready: `Pronto`,
      processing: `Processando`,
      failed: `Falhou`,
    },
    actions: {
      download: `Baixar`,
      edit: `Editar`,
      delete: `Excluir`,
      save: `Salvar`,
      cancel: `Cancelar`,
      moreOptions: `Mais opções`,
      move: `Mover para pasta`,
    },
    selection: {
      selectAll: `Selecionar todos`,
      selectVideo: `Selecionar {{title}}`,
      countInFolder: `{{selected}} de {{total}} selecionados nesta pasta`,
      countFiltered: `{{selected}} de {{total}} selecionados nesta pasta, com filtro aplicado`,
      move: `Mover para pasta`,
      clear: `Limpar seleção`,
      footer_one: `{{count}} selecionado`,
      footer_other: `{{count}} selecionados`,
    },
    moveVideos: {
      title_one: `Mover {{count}} vídeo`,
      title_other: `Mover {{count}} vídeos`,
      description: `Os vídeos saem de "{{source}}" para a pasta escolhida e continuam vinculados às aulas que já os usam.`,
      destination: `Pasta de destino`,
      choose: `Escolha a pasta`,
      noDestination: `Crie outra pasta para ter um destino.`,
      confirm: `Mover`,
      cancel: `Cancelar`,
      close: `Fechar`,
      moving: `Movendo {{done}} de {{total}}…`,
      resultTitle: `{{moved}} de {{total}} vídeos movidos para "{{destination}}"`,
      failedTitle_one: `{{count}} vídeo não foi movido:`,
      failedTitle_other: `{{count}} vídeos não foram movidos:`,
      failedDefaultReason: `Não foi possível mover este vídeo.`,
      reasons: {
        notFound: `Vídeo não encontrado na sua biblioteca.`,
      },
    },
    deleteVideo: {
      title: `Você está prestes a excluir este vídeo permanentemente.`,
      content: `Essa ação não pode ser desfeita.\nO vídeo será removido definitivamente da plataforma.`,
      cancel: `Cancelar`,
      confirm: `Excluir`,
      deleting: `Excluindo...`,
    },
    deleteFolder: {
      title: `Você está prestes a excluir esta pasta.`,
      content: `Os vídeos desta pasta serão movidos para "Vídeos sem pasta".\nEssa ação não pode ser desfeita.`,
      cancel: `Cancelar`,
      confirm: `Excluir`,
      deleting: `Excluindo...`,
    },
    toasts: {
      inProgress: `Upload em andamento. Não feche esta tela.`,
      partialFailed: `Alguns vídeos falharam ao serem enviados. Tente novamente.`,
      failed: `Upload falhou. Tente novamente.`,
      success: `Uploads concluídos com sucesso!`,
      blockClose: `Há uploads em andamento. Aguarde a conclusão antes de fechar.`,
      folderCreated: `Pasta criada.`,
      folderRenamed: `Pasta renomeada.`,
      folderDeleted: `Pasta excluída.`,
      videoRenamed: `Vídeo renomeado.`,
      videoDeleted: `Vídeo excluído.`,
      videosMoved_one: `{{count}} vídeo movido para "{{destination}}".`,
      videosMoved_other: `{{count}} vídeos movidos para "{{destination}}".`,
    },
    empty: {
      noFolders: `Nenhuma pasta encontrada`,
      noVideos: `Nenhum arquivo nesta pasta`,
    },
    download: {
      title: `Seu vídeo está sendo baixado`,
      content: `Estamos finalizando o download pra você.\nNão feche essa página até o download terminar`,
    },
    errors: {
      load: `Não foi possível carregar os vídeos. Tente novamente.`,
      createFolder: `Erro ao criar a pasta. Tente novamente.`,
      renameFolder: `Não foi possível renomear a pasta. Tente novamente.`,
      deleteFolder: `Não foi possível excluir a pasta. Tente novamente.`,
      renameVideo: `Não foi possível renomear o vídeo. Tente novamente.`,
      deleteVideo: `Não foi possível excluir o vídeo. Tente novamente.`,
      moveVideos: `Não foi possível mover os vídeos. Tente novamente.`,
      upload: `Erro ao enviar o vídeo. Tente novamente.`,
      duplicateFile: `Este vídeo já foi adicionado.`,
      maxFilesExceeded_one: `Você pode enviar no máximo {{max}} vídeos por vez. {{count}} vídeo não foi adicionado.`,
      maxFilesExceeded_other: `Você pode enviar no máximo {{max}} vídeos por vez. {{count}} vídeos não foram adicionados.`,
      maxFileSizeExceeded_one: `{{count}} vídeo excede o tamanho máximo de {{max}} e não foi adicionado.`,
      maxFileSizeExceeded_other: `{{count}} vídeos excedem o tamanho máximo de {{max}} e não foram adicionados.`,
      invalidFormat_one: `Formato de arquivo {{names}} inválido. Envie apenas arquivos nos formatos: MP4, MOV, AVI ou MKV. Tente novamente.`,
      invalidFormat_other: `Formato de arquivos {{names}} inválido. Envie apenas arquivos nos formatos: MP4, MOV, AVI ou MKV. Tente novamente.`,
    },
  },
  productMembersArea: {
    lessonMaterials: {
      sectionTitle: `Materiais extras`,
      empty: `Nenhum material adicionado a esta aula.`,
      download: `Baixar`,
      delete: `Excluir`,
      confirmDeleteTitle: `Deseja remover o material?`,
      confirmDeleteContent: `O material será removido da área de membros.`,
      confirmDeleteAction: `Remover material`,
      cancel: `Cancelar`,
      deleteSuccess: `Material excluído com sucesso.`,
      retry: `Tentar novamente`,
      addTitle: `Adicionar material`,
      titleLabel: `Título`,
      descriptionLabel: `Descrição (opcional)`,
      chooseFile: `Escolher arquivo`,
      fileHelperFormats: `Formatos aceitos: {{formats}}.`,
      fileHelperMaxSize: `Tamanho máximo: {{max}} por arquivo.`,
      fileTypeWarning: `Formato fora da lista de aceitos: {{formats}}. O envio pode ser recusado.`,
      limitsLoading: `Carregando os limites de envio…`,
      limitsUnavailable: `Não foi possível carregar os limites de envio. O arquivo será validado ao enviar.`,
      capacity: `Esta aula tem {{total}} de {{max}} materiais. Ainda há espaço para {{remaining}}.`,
      capacityReached: `Esta aula atingiu o limite de {{max}} materiais. Para adicionar outro, remova um dos atuais.`,
      capacityExceeded: `Esta aula tem {{total}} materiais, acima do limite de {{max}}. Todos continuam disponíveis para os alunos, mas para adicionar um novo é preciso remover pelo menos {{toRemove}}.`,
      capacityQueueExceeded: `A fila passa do limite de {{max}} materiais por aula: remova {{excess}} da fila antes de salvar.`,
      uploading: `Enviando… {{percent}}% · {{loaded}} de {{total}}`,
      cancelUpload: `Cancelar envio`,
      uploadCanceled: `Envio cancelado. Nenhum material foi adicionado.`,
      flushCanceled: `Envio cancelado. Os materiais que não subiram continuam na lista para você tentar de novo.`,
      addButton: `Adicionar`,
      createSuccess: `Material adicionado com sucesso.`,
      errors: {
        load: `Erro ao carregar os materiais da aula.`,
        create: `Erro ao adicionar o material. Tente novamente.`,
        delete: `Erro ao excluir o material. Tente novamente.`,
        download: `Erro ao baixar o material. Tente novamente.`,
        popupBlocked: `O navegador bloqueou a nova aba. Permita pop-ups para este site e tente de novo.`,
        notFound: `Material não encontrado.`,
        lessonNotFound: `Aula não encontrada.`,
        forbidden: `Você não tem permissão para esta ação.`,
        fileTooLarge: `Arquivo muito grande. Tamanho máximo: {{max}} por arquivo.`,
        invalidFileType: `Formato não aceito. Envie um arquivo em um destes formatos: {{formats}}.`,
        uploadTimeout: `O envio demorou mais do que o permitido e foi interrompido. Nenhum material foi adicionado. Tente uma conexão mais rápida ou um arquivo menor.`,
        uploadNetwork: `A conexão caiu durante o envio. Nenhum material foi adicionado. Verifique a conexão e tente de novo.`,
        batchOverLimit: `Nenhum material foi enviado: a aula aceita até {{max}} materiais e há espaço para mais {{available}}. Remova {{excess}} da fila e salve de novo.`,
        invalidFileKey: `Chave de arquivo inválida.`,
        titleRequired: `O título é obrigatório.`,
      },
    },
  },
  subscriptionsDrawer: {
    canceledBy: {
      subscriber: `Cancelada pelo assinante`,
      producer: `Cancelada pelo produtor`,
      api: `Cancelada pela integração (API)`,
      system: `Cancelada pela Cakto`,
    },
    cancellationReason: `Motivo: {{reason}}`,
  },
  demo: {
    title: `Português`,
    introduction: `Lorem Ipsum é simplesmente um texto fictício da indústria de impressão e tipografia. Lorem Ipsum é o texto padrão da indústria desde os anos 1500, quando um impressor desconhecido pegou uma galeria de tipos e a embaralhou para fazer um livro de amostras de tipos. Ele não só sobreviveu a cinco séculos, como também ao salto para a tipografia eletrônica, permanecendo essencialmente inalterado. Foi popularizado nos anos 1960 com o lançamento de folhas Letraset com passagens de Lorem Ipsum e, mais recentemente, com programas de editoração eletrônica como o Aldus PageMaker, incluindo versões de Lorem Ipsum.`,
  },
  docs: {
    hi: `Olá`,
    description: `Precisa de ajuda? \n Confira nossa documentação.`,
    documentation: `documentação`,
  },
  languages: {
    pt: `Português`,
    en: `Inglês`,
    es: `Espanhol`,
    cn: `Chinês`,
  },
  pagination: {
    previousPage: `Página anterior`,
    nextPage: `Próxima página`,
  },
  app: `aplicativo`,
  user: `usuário`,
  list: `lista`,
  edit: `editar`,
  shop: `loja`,
  blog: `blog`,
  post: `publicação`,
  mail: `e-mail`,
  chat: `chat`,
  cards: `cartões`,
  posts: `publicações`,
  create: `criar`,
  kanban: `kanban`,
  general: `geral`,
  banking: `financeiro`,
  booking: `reservas`,
  profile: `perfil`,
  account: `conta`,
  product: `produto`,
  invoice: `fatura`,
  details: `detalhes`,
  checkout: `finalizar compra`,
  calendar: `calendário`,
  analytics: `análises`,
  ecommerce: `e-commerce`,
  management: `gestão`,
  menu_level: `nível do menu`,
  menu_level_2a: `nível do menu 2a`,
  menu_level_2b: `nível do menu 2b`,
  menu_level_3a: `nível do menu 3a`,
  menu_level_3b: `nível do menu 3b`,
  menu_level_4a: `nível do menu 4a`,
  menu_level_4b: `nível do menu 4b`,
  item_disabled: `item desativado`,
  item_label: `rótulo do item`,
  item_caption: `legenda do item`,
  item_external_link: `link externo do item`,
  description: `descrição`,
  other_cases: `outros casos`,
  item_by_roles: `item por função`,
  only_admin_can_see_this_item: `Apenas o administrador pode ver este item`,
  ratingSurvey: {
    logoAlt: `Logo Cakto`,
    pageTitle: `Queremos saber a sua opinião!`,
    pageSubtitle: `Sua resposta nos ajuda a melhorar continuamente nossos produtos.`,
    satisfactionQuestion: `Qual seu nível de satisfação com o produto?`,
    commentLabel: `Pode nos contar o motivo de sua nota?`,
    commentPlaceholder: `Digite aqui sua resposta...`,
    charCount: `{{count}}/500 caracteres`,
    submit: `Enviar feedback`,
    submitting: `Enviando...`,
    errorGeneric: `Erro ao enviar avaliação. Tente novamente.`,
    cactusLabels: {
      1: { line1: `Muito`, line2: `Insatisfeito!` },
      2: { line1: `Insatisfeito`, line2: `` },
      3: { line1: `Neutro`, line2: `` },
      4: { line1: `Satisfeito!`, line2: `` },
      5: { line1: `Muito`, line2: `Satisfeito!` },
    },
    validation: {
      ratingRequired: `Avaliação é obrigatória`,
      ratingMin: `Selecione pelo menos 1 cacto`,
      ratingMax: `Máximo 5 cactos`,
      commentRequired: `Comentário obrigatório`,
      commentMin: `Por favor, descreva melhor sua experiência (mínimo 10 caracteres)`,
    },
    errorState: {
      expired: {
        title: `Seu link de pesquisa expirou`,
        messageBold: `A pesquisa fica disponível por até 7 dias após a realização da compra.`,
        messageNormal: `Esse prazo garante que o feedback esteja relacionado à sua experiência mais recente. Se desejar, você poderá participar novamente em uma próxima compra.`,
      },
      already_used: {
        title: `Avaliação Já Enviada`,
        message: `Você já enviou sua avaliação para este produto. Obrigado pelo seu feedback!`,
      },
      error: {
        title: `Link Inválido`,
        message: `Este link não é válido. Verifique se copiou o link completo do e-mail.`,
      },
      goToPlatform: `Ir para a plataforma`,
    },
  },
  subscriberFlow: {
    common: {
      logoAlt: `Logo Cakto`,
      loadError: {
        title: `Não foi possível carregar`,
        description: `Tivemos um problema para buscar suas informações. Isso não quer dizer que você não tem assinaturas.`,
        retry: `Tentar de novo`,
      },
      backToSubscriptions: `Minhas assinaturas`,
      signOut: `Sair`,
      price: `{{amount}}/{{interval}}`,
      interval: {
        monthly: `mês`,
        yearly: `ano`,
        weekly: `semana`,
        everyNDays: `{{days}} dias`,
      },
      paymentMethod: {
        card: `Cartão de crédito`,
        cardWithDigits: `Cartão •••• {{lastDigits}}`,
        automaticPix: `Pix Automático`,
        pix: `Pix`,
        boleto: `Boleto`,
      },
    },
    home: {
      title: `Minhas assinaturas`,
      description: `Acesse com o e-mail ou telefone usado na compra. Sem senha e sem novo cadastro — enviamos um código de verificação.`,
      identifierLabel: `E-mail ou telefone usado na compra`,
      identifierPlaceholder: `Digite seu e-mail ou telefone (com DDD)`,
      sendCode: `Receber código de acesso`,      
      comingSoon: `Em Breve`,
      google: {
        signIn: `Entrar com Google`,
        or: `ou`,
        signingIn: `Entrando com o Google…`,
        notice: {
          noAccount: `Não encontramos uma conta ou assinatura com o e-mail do Google. Informe o e-mail ou o telefone usado na compra.`,
          useCode: `Para este e-mail, confirme pelo código: informe o e-mail abaixo.`,
          expired: `Sua entrada com o Google expirou. Tente de novo.`,
          failed: `Não foi possível entrar com o Google. Tente de novo.`,
        },
      },
      link: {
        signingIn: `Abrindo sua assinatura…`,
        notice: {
          invalid: `Este link de acesso expirou ou não vale mais. Entre com o e-mail usado na compra para continuar.`,
          failed: `Não conseguimos abrir sua assinatura pelo link agora. Entre com o e-mail usado na compra para continuar.`,
          sessionEnded: `Sua sessão pelo link terminou. Abra o link do aviso de novo ou entre com o e-mail da compra.`,
        },
      },
      validation: {
        identifierRequired: `Informe o e-mail ou o telefone usado na compra`,
        identifierInvalid: `Informe um e-mail válido ou um telefone com DDD`,
      },
      toast: {
        codeResent: `Código reenviado.`,
        codeResentEmail: `Código reenviado. Confira seu e-mail.`,
        codeResentWhatsapp: `Código reenviado. Confira seu WhatsApp.`,
      },
      errors: {
        sendCode: `Não foi possível enviar o código. Tente novamente em alguns instantes.`,
        tooManyAttempts: `Muitas tentativas em pouco tempo. Aguarde um minuto e tente de novo.`,
        phoneLoginUnavailable: `O acesso por telefone está indisponível no momento. Use o e-mail da compra.`,
      },
    },
    verifyCode: {
      description: `Enviamos um código de 6 dígitos para {{identifier}}.`,
      descriptionEmail: `Enviamos um código de 6 dígitos para {{identifier}} por e-mail.`,
      descriptionWhatsapp: `Enviamos um código de 6 dígitos para {{identifier}} por WhatsApp.`,
      codeLabel: `Código de verificação`,
      codePlaceholder: `000000`,
      submit: `Entrar`,
      changeIdentifier: `Trocar e-mail/telefone`,
      resendCode: `Reenviar código`,
      resendCodeIn: `Reenviar código em {{seconds}}s`,
      resendCodeLocked: `Reenviar código em {{minutes}} min`,
      lockOver: `O tempo de espera acabou. Peça um novo código para entrar.`,
      validation: {
        codeInvalid: `Digite o código de 6 dígitos que enviamos.`,
      },
      errors: {
        confirmCode: `Não foi possível confirmar o código. Tente novamente.`,
        wrongCode: `Código inválido ou expirado. Confira o código ou peça um novo.`,
        locked: `Muitas tentativas com código errado. Por segurança, aguarde {{minutes}} min e peça um novo código.`,
      },
    },
    header: {
      loggedInAs: `Sessão de`,
      linkAccess: `Acesso pelo link do aviso`,
      signInWithEmail: `Entrar com e-mail`,
    },
    subscriptionsPage: {
      title: `Minhas assinaturas`,
      description: `Gerencie pagamento e acompanhe suas assinaturas ativas. Sessão de {{identifier}} — sem novo cadastro.`,
      descriptionLink: `Você entrou pelo link do aviso e vê só esta assinatura. Para ver as outras, entre com o e-mail da compra.`,
      status: {
        active: `Ativa`,
        inactive: `Inativa`,
        paymentPending: `Pagamento pendente`,
        chargeProcessing: `Processando cobrança`,
        canceled: `Cancelada`,
        expired: `Expirada`,
        paused: `Pausada`,
        trial: `Em teste`,
        late: `Atrasada`,
      },
      caption: {
        active: `{{price}} · {{method}} · próxima cobrança em {{nextChargeAt}}`,
        canceled: `{{price}} · {{method}} · cancelada em {{canceledAt}} · próximas cobranças interrompidas`,
        canceledWithoutDate: `{{price}} · {{method}} · cancelada · próximas cobranças interrompidas`,
        paymentPending: `{{price}} · pagamento não identificado em {{failedAt}}`,
        paymentPendingWithoutDate: `{{price}} · pagamento não identificado`,
      },
      pendingCallout: `Sua cobrança não foi aprovada. Novas tentativas automáticas serão feitas — atualize seu método de pagamento até a última tentativa ({{lastRetryAt}}) para evitar o cancelamento por inadimplência.`,
      pendingCalloutWithoutDate: `Sua cobrança não foi aprovada. Novas tentativas automáticas serão feitas — atualize seu método de pagamento antes da última tentativa para evitar o cancelamento por inadimplência.`,
      pendingCalloutWithoutRetry: `Sua cobrança não foi aprovada, e não haverá novas tentativas automáticas.`,
      pendingCalloutPixRenewalExpired: `O Pix da renovação venceu e não pode mais ser pago. Escolha como pagar para manter sua assinatura.`,
      resolvedByAutomaticPixCallout: `Pix Automático autorizado. A nova cobrança está sendo processada — se aprovada, a inadimplência é encerrada e o status volta para "Ativa".`,
      actions: {
        resolveNow: `Resolver agora`,
        changePaymentMethod: `Trocar método de pagamento`,
        reactivate: `Assinar de novo`,
        viewHistory: `Ver histórico`,
        cancelSubscription: `Cancelar assinatura`,
        cancelNeedsEmail: `Para cancelar, entre com o e-mail da compra`,
      },
      empty: {
        title: `Você ainda não tem assinaturas`,
        description: `Quando você assinar um produto na Cakto, ele aparece aqui — ativo ou encerrado — com status, valor e data da próxima cobrança.`,
      },
      reactivateHint: `Isso cria uma assinatura nova, no preço e nas condições que a oferta tem hoje. A assinatura antiga permanece encerrada.`,
      support: `Precisa de ajuda? Fale com o produtor pelo e-mail de suporte informado na compra.`,
      toast: {
        subscriptionCanceled: `Assinatura cancelada. As próximas cobranças param agora.`,
        cancelFailed: `Não foi possível cancelar a assinatura. Tente novamente ou fale com o suporte.`,
      },
    },
    cancelDialog: {
      title: `Cancelar assinatura`,
      description: `A assinatura {{productName}} será cancelada. As próximas cobranças param agora.`,
      irreversible: `Esta ação não pode ser desfeita. Para voltar a ter acesso depois, será preciso assinar de novo, no preço e nas condições vigentes.`,
      inputLabel: `Digite {{phrase}} para confirmar`,
      inputHelper: `Confirmação obrigatória para evitar cancelamento por engano.`,
      keep: `Manter assinatura`,
      confirm: `Confirmar cancelamento`,
      confirmationPhrase: `CANCELAR ASSINATURA`,
      reasonLabel: `Por que você está cancelando? (opcional)`,
      reasons: {
        preferNotToSay: `Prefiro não dizer`,
        tooExpensive: `Ficou caro`,
        notUsing: `Não estou usando`,
        notAsExpected: `Não era o que eu esperava`,
        accessProblem: `Problema de acesso`,
        other: `Outro motivo`,
      },
      errors: {
        alreadyCanceled: `Esta assinatura já está cancelada.`,
        notCancelable: `Esta assinatura não pode ser cancelada por aqui no momento. Fale com o produtor pelo e-mail de suporte informado na compra.`,
        notLinked: `Não encontramos esta assinatura para cancelar. Fale com o produtor pelo e-mail de suporte informado na compra.`,
        cancelDisabled: `O cancelamento pelo portal está indisponível no momento. Tente de novo mais tarde.`,
        cancelLateDisabled: `Com o pagamento pendente, o cancelamento por aqui está indisponível no momento. Resolva o pagamento ou tente de novo mais tarde.`,
        invalidReason: `Não reconhecemos o motivo escolhido. Escolha outro, ou "Prefiro não dizer", e tente de novo.`,
        emailScopeRequired: `Para cancelar, entre com o e-mail usado na compra.`,
        unavailable: `Não foi possível cancelar agora, e a assinatura não mudou. Tente de novo em alguns minutos.`,
        unconfirmed: `Não conseguimos confirmar o cancelamento. Confira a sua lista de assinaturas antes de tentar de novo.`,
        tooManyAttempts: `Muitas tentativas de cancelamento. Aguarde um pouco e tente de novo mais tarde.`,
      },
    },
    paymentPage: {
      title: `Atualizar forma de pagamento`,
      contextPending: `{{productName}} · {{price}} · pagamento pendente desde {{failedAt}}`,
      contextPendingWithoutDate: `{{productName}} · {{price}} · pagamento pendente`,
      contextActive: `{{productName}} · {{price}} · em dia`,
      callouts: {
        recoveryEmail: `Você chegou pelo e-mail de recuperação — esta é a assinatura pendente mencionada nele.`,
        renewalReminder: `Você chegou pelo lembrete de renovação. Aqui você confere o meio de pagamento da próxima cobrança e pode trocá-lo antes da renovação.`,
      },
      notFound: {
        title: `Assinatura não encontrada`,
        description: `Não a encontramos entre as suas. Se você chegou por um e-mail, entre com o e-mail ou o telefone usado nessa compra.`,
        switchAccount: `Entrar com outro e-mail ou telefone`,
      },
      errors: {
        subscriptionNotLinked: `Não é possível alterar o pagamento desta assinatura por aqui. Fale com o produtor pelo e-mail de suporte informado na compra.`,
        subscriptionEnded: `Esta assinatura foi encerrada. Para continuar, assine de novo.`,
        pixPaymentPending: `Você já tem um Pix gerado para esta cobrança. Pague o Pix ou espere ele vencer para usar outra forma de pagamento.`,
        paymentMethodNotEnabled: `Esta forma de pagamento não está disponível para esta assinatura. Escolha outra.`,
      },
      methods: {
        creditCard: `Cartão de crédito`,
        automaticPix: `Pix Automático`,
        pix: `Pix`,
      },
      card: {
        holderNameLabel: `Nome do titular`,
        holderNamePlaceholder: `Como está impresso no cartão`,
        numberLabel: `Número do cartão`,
        numberPlaceholder: `0000 0000 0000 0000`,
        expirationLabel: `Validade`,
        expirationPlaceholder: `MM/AA`,
        cvvLabel: `CVV`,
        cvvPlaceholder: `000`,
        submitPending: `Salvar e executar nova cobrança`,
        submitActive: `Salvar novo cartão`,
        footnote: `A cobrança pendente é processada imediatamente no novo cartão. Seu histórico anterior é mantido.`,
        retry: `Tentar de novo`,
        errors: {
          infrastructure: `Não conseguimos processar a cobrança agora. Tente novamente em alguns minutos.`,
          cardNotProcessed: `Não conseguimos processar este cartão. Confira os dados ou use outro cartão.`,
          issuerTimed: `O banco emissor recusou a cobrança agora, por exemplo por limite ou saldo insuficiente. Use outro cartão ou tente mais tarde.`,
          issuer: `A cobrança foi recusada pelo banco emissor do cartão. Use outro cartão.`,
          notApproved: `A cobrança não foi aprovada. Use outro cartão.`,
          chargeInProgress: `Não foi possível salvar o cartão agora. Pode já haver uma cobrança desta assinatura em andamento: confira a assinatura antes de tentar de novo.`,
          unconfirmed: `Não conseguimos confirmar a troca do cartão nem a cobrança. Confira a assinatura em alguns minutos antes de tentar de novo.`,
          tooManyAttempts: `Você fez muitas tentativas. Aguarde um pouco antes de tentar de novo.`,
          emailScopeRequired: `Para alterar a assinatura, entre com o e-mail usado na compra.`,
          invalidCard: `Confira os dados do cartão.`,
          generic: `Não foi possível salvar o cartão.`,
        },
        validation: {
          holderNameRequired: `Digite o nome do titular como está no cartão.`,
          numberInvalid: `Digite os 16 dígitos do cartão.`,
          expirationFormat: `Use o formato MM/AA.`,
          expirationMonth: `Mês inválido. Use 01 a 12.`,
          expirationExpired: `Cartão vencido. Use um cartão com validade futura.`,
          cvvInvalid: `CVV tem 3 dígitos. Confira no verso do cartão.`,
        },
      },
      automaticPix: {
        explanation: `O Pix Automático debita o valor da assinatura direto da sua conta, todo ciclo, sem você precisar fazer nada. Você autoriza uma única vez no app do seu banco.`,
        start: `Gerar autorização no meu banco`,
        footnote: `Seu histórico de cobranças anteriores é mantido após a migração.`,
        waitingTitle: `Aguardando confirmação do seu banco`,
        waitingDescription: `Abra o app do seu banco, escaneie o código e autorize o Pix Automático da {{productName}} ({{price}}).`,
        waitingPolling: `Verificando a cada 5 segundos…`,
        waitingBack: `Voltar`,
        pollingExhausted: `Não recebemos a confirmação do seu banco. Se você já autorizou, aguarde alguns minutos e recarregue a página.`,
        generatingQr: `Gerando código…`,
        pendingWithoutQr: `Já existe uma autorização aguardando o seu banco.`,
        applyingTitle: `Aprovada pelo banco, aplicando a troca`,
        applyingDescription: `Seu banco autorizou o Pix Automático da {{productName}}. Estamos trocando a forma de pagamento da sua assinatura, o que leva alguns instantes.`,
        applyingExhausted: `Seu banco aprovou. A troca ainda está sendo aplicada; volte em alguns minutos.`,
        copyCode: `Copiar código Pix`,
        codeCopied: `Código Pix copiado.`,
        copyFailed: `Não foi possível copiar o código.`,
        unavailable: {
          disabled: `O Pix Automático está indisponível no momento. Use o cartão de crédito.`,
          subscription: `O Pix Automático não está disponível para esta assinatura. Use o cartão de crédito.`,
          alreadyActive: `Esta assinatura já está no Pix Automático.`,
          notDelinquent: `O Pix Automático é autorizado junto com uma cobrança em aberto, e esta assinatura está em dia.`,
        },
      },
      noMethods: `Não é possível pagar esta assinatura por aqui. Fale com o produtor pelo e-mail de suporte informado na compra.`,
      pix: {
        generating: `Gerando o Pix…`,
        title: `Pague com Pix`,
        description: `Abra o app do seu banco e pague {{amount}} da {{productName}} com o QR Code ou o código copia e cola.`,
        expiresAt: `Válido até {{expiresAt}}`,
        copyCode: `Copiar código Pix`,
        codeCopied: `Código Pix copiado.`,
        copyFailed: `Não foi possível copiar o código.`,
        waitingPolling: `Aguardando o pagamento. Verificando a cada 5 segundos…`,
        pollingExhausted: `Ainda não recebemos a confirmação do pagamento.`,
        checkAgain: `Já paguei, verificar de novo`,
        expired: `Este Pix venceu e não pode mais ser pago. Gere um novo para pagar.`,
        canceled: `Este Pix foi cancelado e não pode mais ser pago. Gere um novo para pagar.`,
        generateNew: `Gerar novo Pix`,
        retry: `Tentar de novo`,
        footnote: `A assinatura continua no Pix: as próximas renovações também chegam por QR Code.`,
        errors: {
          notEnabled: `O Pix não está disponível para esta assinatura. Escolha outra forma de pagamento.`,
          notDelinquent: `Não há cobrança em aberto nesta assinatura: ela já está em dia.`,
          chargeInProgress: `Já há uma cobrança desta assinatura em andamento. Confira a assinatura antes de gerar um Pix.`,
          unavailable: `Não conseguimos gerar o Pix agora. Tente de novo em alguns minutos.`,
          generic: `Não foi possível gerar o Pix.`,
        },
      },
      toast: {
        cardUpdated: `Método de pagamento atualizado.`,
        chargeProcessing: `A cobrança no novo cartão está em processamento. A assinatura é atualizada assim que o banco confirmar.`,
        automaticPixAuthorized: `Pix Automático autorizado.`,
        automaticPixFailed: `Não foi possível gerar a autorização. Tente novamente.`,
        automaticPixRejected: `Seu banco não autorizou o Pix Automático. Tente novamente ou use cartão.`,
      },
    },
    historyPage: {
      title: `Histórico de pagamentos`,
      subtitle: `{{productName}} · {{price}}`,
      chargeStatus: {
        paid: `Aprovada`,
        refused: `Recusada`,
        retrying: `Em retentativa`,
        waitingPayment: `Aguardando pagamento`,
        scheduled: `Agendada`,
        refunded: `Reembolsada`,
        chargedback: `Chargeback`,
        canceled: `Cancelada`,
        processing: `Processando`,
        authorized: `Autorizada`,
        refundRequested: `Reembolso solicitado`,
        inSettlement: `Reembolso em processamento`,
        acquirerError: `Reembolso não concluído`,
        blocked: `Bloqueada`,
        inProtest: `Em protesto`,
        partiallyPaid: `Parcialmente paga`,
        prechargeback: `Em contestação`,
        med: `Em análise (MED)`,
      },
      detail: {
        firstCharge: `1ª cobrança`,
        coupon: `cupom {{code}}`,
        retry: `retentativa {{attempt}}`,
        settledAt: `liquidada em {{paidAt}}`,
      },
      footnote: `Cada tentativa fica registrada com o motivo da recusa quando disponível — nada é omitido.`,
      empty: `Nenhuma cobrança registrada nesta assinatura ainda.`,
    },
    successPage: {
      titleCard: `Inadimplência encerrada`,
      titleAutomaticPix: `Pix Automático autorizado`,
      titlePix: `Pagamento confirmado`,
      bodyCard: `O sistema executou uma nova cobrança da {{productName}} no novo cartão e ela foi aprovada. Seu acesso está garantido e a próxima cobrança será em {{nextChargeAt}}.`,
      bodyAutomaticPix: `Recebemos a autorização do seu banco. O sistema está executando a nova cobrança da {{productName}} — você não precisa fazer mais nada.`,
      bodyPix: `Recebemos o Pix da {{productName}}. Seu acesso está garantido e a próxima cobrança será em {{nextChargeAt}}.`,
      statusLabel: `Status da assinatura:`,
      back: `Voltar às minhas assinaturas`,
      footnote: `A inadimplência foi encerrada: régua de retentativas interrompida, próxima cobrança recalculada, confirmação enviada por e-mail e WhatsApp e webhook disparado.`,
    },
  },
  refundFlow: {
    common: {
      logoAlt: `Logo Cakto`,
      back: `Voltar`,
      of: `de`,
    },
    headerPurchase: {
      loggedInAs: `Você está logado(a) como`,
      signOut: `Sair`,
    },
    purchasesPage: {
      title: `Minhas compras`,
    },
    home: {
      title: `Solicitar reembolso`,
      descriptionLine1: `Você pode solicitar um reembolso até 7 dias após a compra.`,
      descriptionLine2: `Ao solicitar um reembolso, a sua compra será cancelada e você não terá mais acesso ao produto.`,
      identifierLabel: `E-mail ou telefone usado na compra`,
      identifierPlaceholder: `Digite seu e-mail ou telefone (com DDD)`,
      findPurchase: `Encontrar sua compra`,
      google: {
        signIn: `Entrar com Google`,
        or: `ou`,
        signingIn: `Entrando com o Google…`,
        notice: {
          noAccount: `Não encontramos uma conta ou compra com o e-mail do Google. Informe o e-mail ou o telefone usado na compra.`,
          useCode: `Para este e-mail, confirme pelo código: informe o e-mail abaixo.`,
          expired: `Sua entrada com o Google expirou. Tente de novo.`,
          failed: `Não foi possível entrar com o Google. Tente de novo.`,
        },
      },
      validation: {
        identifierRequired: `Informe o e-mail ou o telefone usado na compra`,
        identifierInvalid: `Informe um e-mail válido ou um telefone com DDD`,
      },
      errors: {
        sendCode: `Ocorreu um erro ao enviar o código, favor tentar novamente mais tarde`,
      },
    },
    verifyEmail: {
      exit: `Sair`,
      title: `Verifique o seu email`,
      titleWhatsapp: `Verifique o seu WhatsApp`,
      description: `Se o e-mail {{email}} estiver vinculado a uma compra, você receberá um código de verificação. Digite-o abaixo para continuar.`,
      descriptionWhatsapp: `Se o número {{phone}} estiver vinculado a uma compra, você receberá um código de verificação no WhatsApp. Digite-o abaixo para continuar.`,
      resendCode: `Reenviar código`,
      continue: `Confirmar código`,
      errors: {
        invalidOrExpiredToken: `Token inválido ou expirado. Refaça o processo de verificação.`,
      },
    },
    purchase: {
      pageHeading: `Solicitar reembolso`,
      pageSubtitle: `Confira os dados da compra e escolha o motivo do pedido. Campos marcados como obrigatórios precisam ser preenchidos para continuar.`,
      loadingDetails: `Carregando detalhes da compra…`,
      loadError: `Não foi possível carregar esta compra. Verifique sua conexão e tente novamente.`,
      retry: `Tentar novamente`,
      orderNotFound: `Não encontramos esta compra na sua lista ou você não tem permissão para vê-la.`,
      orderNotFoundCta: `Ver minhas compras`,
      backNavAria: `Voltar para a lista de compras`,
      backToRefundRequest: `Solicitar reembolso`,
      productDetailsTitle: `Detalhes do produto`,
      refundReasonTitle: `Motivo do Reembolso`,
      selectReasonRequired: `Selecione o motivo do reembolso (obrigatório)*`,
      otherReason: `Outro motivo`,
      explainLabel: `Explique com suas palavras`,
      explainPlaceholder: `Conte ao vendedor com mais detalhes por que você está pedindo um reembolso`,
      requestRefundButton: `Solicitar reembolso`,
      installments: `{{installments}}x de {{amount}}`,
      fields: {
        productName: `Nome do produto`,
        amount: `Valor`,
        purchaseDate: `Data da compra`,
        refundDeadline: `Data limite para solicitar reembolso`,
        paymentMethod: `Método de pagamento`,
        supportEmail: `E-mail de suporte do vendedor`,
        producerName: `Nome do vendedor`,
      },
      paymentMethods: {
        pix: `Pix`,
        creditCard: `Cartão`,
        ticket: `Boleto`,
        billet: `Boleto`,
        oxxo: `OXXO`,
        spei: `SPEI`,
        pixAuto: `Pix Automático`,
        boleto: `Boleto`,
        debitCard: `Cartão de débito`,
        pagaleveInstallments: `Pix em {{installments}}x sem juros`,
        pagaleveUpfront: `Pix à vista`,
        picpay: `PicPay`,
        googlepay: `Google Pay`,
        applepay: `Apple Pay`,
        paypal: `PayPal`,
        nubank: `Nubank`,
        mercadopago: `Mercado Pago`,
        pse: `PSE`,
        nequi: `Nequi`,
        safetypay: `SafetyPay`,
        unknown: `Desconhecido`,
      },
      refundReasons: {
        optionAccessIssue: `Eu ainda não consegui acessar o produto, mas gostaria de acessar`,
        optionNeedMoney: `Preciso do dinheiro para outras coisas`,
        optionFilesNotOpening: `Recebi o acesso, mas as páginas ou arquivos não abrem`,
        optionNoSupportResponse: `O vendedor não responde as minhas solicitações de suporte`,
        optionLowQuality: `A qualidade do produto não atingiu as minhas expectativas`,
        optionIncompleteProduct: `O produto está incompleto`,
        optionDuplicatePurchase: `Compra duplicada`,
      },
      bankInfo: {
        title: `Dados bancários para o estorno`,
        descriptionRequired: `Este pagamento foi feito em dinheiro, então precisamos da conta em que você quer receber o valor de volta. Sem esses dados não conseguimos concluir o estorno.`,
        descriptionOptional: `Se quiser receber o estorno em uma conta específica, informe os dados abaixo. Você também pode deixar em branco.`,
        fields: {
          clabe: `CLABE`,
          clabeHelper: `Os 18 dígitos da sua conta CLABE`,
          bank_account_holder_name: `Nome do titular da conta`,
          bank_account_holder_document: `Documento do titular (CURP ou RFC)`,
          bank_name: `Banco`,
          bank_branch: `Agência`,
          bank_account: `Conta`,
          account_type: `Tipo de conta`,
        },
        validation: {
          clabe: `CLABE inválida. Confira os 18 dígitos.`,
          maxLength: `Valor acima do tamanho permitido`,
        },
      },
      validation: {
        required: `Campo obrigatório`,
      },
      errors: {
        requestRefund: `Houve um erro ao tentar realizar o reembolso, favor entrar em contato direto com o vendedor.`,
      },
    },
    successModal: {
      title: `Reembolso confirmado`,
      description: `Recebemos seu pedido e ele já está em processamento.`,
      deadlineTitle: `Você será reembolsado em até 24 horas`,
      deadlineDescription: `O valor volta automaticamente, sem precisar de aprovação do vendedor.`,
      deadlineDescriptionWithAmount: `Os {{amount}} voltam automaticamente, sem precisar de aprovação do vendedor.`,
      stepEmail: `Enviamos a confirmação para o seu e-mail.`,
      stepMethod: `A devolução é integral e no mesmo meio de pagamento da compra.`,
      trackRefund: `Acompanhar meu reembolso`,
      backHome: `Voltar para a página inicial`,
    },
    confirmCancelRefund: {
      title: `Seu reembolso está em andamento`,
      greeting: `Oi, {{userFirstName}}! Tudo bem?`,
      processingMessage: `Recebemos sua solicitação de reembolso do produto {{productName}} e já estamos processando. O valor de {{currentPrice}} será devolvido em até 24 horas úteis.`,
      changedMindTitle: `Mudou de ideia?`,
      changedMindDescription: `Se você quiser manter o produto, pode cancelar o reembolso aqui:`,
      keepPurchase: `Manter minha compra`,
      orderDetailsTitle: `Detalhes do pedido`,
      orderIdLabel: `ID:`,
      orderAmountLabel: `Valor:`,
      supportMessage: `Se tiver dúvidas sobre o produto, entre em contato com o suporte do produtor a partir do e-mail abaixo:`,
      orCountOn: `ou conte com o`,
      caktoSupport: `suporte da Cakto`,
      snackbar: {
        success: `Reembolso cancelado com sucesso`,
        error: `Erro ao cancelar reembolso`,
      },
    },
    howRefundsWork: {
      title: `Como funciona o reembolso?`,
      description: `Nossa política garante 7 dias corridos para solicitação de reembolso em qualquer compra. Enviada a solicitação, seu reembolso é processado automaticamente em até 24 horas — o vendedor é avisado e tem esse prazo para falar com você, mas a devolução não depende da aprovação dele. O valor é restituído integralmente no mesmo método de pagamento utilizado na compra.`,
    },
    modalTrySupport: {
      title: `Precisa de ajuda com sua compra?`,
      descriptionLine1: `Muitos problemas podem ser resolvidos rapidamente com o produtor.`,
      descriptionLine2: `Se preferir, fale com o suporte antes de seguir com o reembolso:`,
      talkToSupport: `Contatar suporte`,
      continueRefund: `Continuar reembolso`,
    },
    modalRefundBlocked: {
      title: `Este reembolso é feito com o produtor`,
      descriptionLine1: `O produtor é o responsável pelo reembolso deste produto.`,
      descriptionLine2: `Entre em contato com ele pelo e-mail abaixo para solicitar seu reembolso.`,
      talkToSupport: `Falar com o produtor`,
    },
    modalRefundInsufficientBalance: {
      title: `Não foi possível solicitar o reembolso agora`,
      description: `Não há saldo disponível para a devolução desta compra, por isso o seu pedido de reembolso não foi aberto.`,
      productSupport: `Fale com o suporte do produto pelo e-mail abaixo:`,
      caktoSupportFallback: `Se não resolver, fale com o suporte da Cakto.`,
      caktoSupportOnly: `Fale com o suporte da Cakto para saber como seguir.`,
      talkToProductSupport: `Falar com o suporte do produto`,
      talkToCaktoSupport: `Falar com o suporte da Cakto`,
      close: `Fechar`,
    },
    purchaseCard: {
      productImageAlt: `Produto`,
      fields: {
        amount: `Valor:`,
        purchaseDate: `Data da compra:`,
        refundDeadline: `Data limite para solicitar reembolso:`,
        refundDeadlineShort: `Reembolso até:`,
        status: `Status:`,
        unknown: `Desconhecido`,
      },
      status: {
        processing: `Processando`,
        authorized: `Autorizado`,
        paid: `Pago`,
        refunded: `Reembolsado`,
        waiting_payment: `Aguardando pagamento`,
        refused: `Recusado`,
        chargedback: `Chargeback`,
        canceled: `Cancelado`,
        in_protest: `Em protesto`,
        partially_paid: `Parcialmente pago`,
        refund_requested: `Reembolso em processamento`,
        acquirer_error: `Reembolso não concluído`,
        in_settlement: `Reembolso em processamento`,
        expired: `Expirado`,
      },
      refundFailed: {
        title: `Não foi possível concluir o seu reembolso`,
        description: `O vendedor, ou um dos afiliados dele, não tem saldo disponível para devolver o valor. Entre em contato diretamente com ele pelo e-mail abaixo:`,
      },
      refundInProgress: {
        title: `Reembolso em processamento`,
        description: `O valor será devolvido em até 24 horas, no mesmo meio de pagamento da compra.`,
      },
      refundSent: {
        title: `Reembolso enviado ao meio de pagamento`,
        description: `Este reembolso já não pode ser cancelado. Estamos aguardando a confirmação do meio de pagamento, e o prazo para o valor aparecer depende do seu banco ou da operadora do cartão.`,
      },
      refundInReview: {
        title: `Seu reembolso está em revisão`,
        description: `O meio de pagamento não confirmou a devolução e o nosso time está verificando. Você não precisa pedir de novo. Se quiser falar com o vendedor, use o e-mail abaixo:`,
      },
      requestRefund: `Solicitar reembolso`,
      expiredRefund: `Reembolso expirado`,
      refundBlocked: `Reembolso bloqueado`,
      cancelRefund: `Cancelar Reembolso`,
      snackbar: {
        notFound: `Nenhuma solicitação de reembolso encontrada`,
        expiredUpdating: `Solicitação de reembolso expirada, estamos atualizando as informações`,
      },
    },
    renderPurchaseCards: {
      empty: `Nenhuma compra encontrada!`,
    },
  },
  checkoutBuilder: {
    v1Mock: {
      fullName: 'Nome completo',
      fullNamePlaceholder: 'Preencha seu nome',
      emailPlaceholder: 'Preencha seu email',
      confirmEmailPlaceholder: 'Confirme seu email',
      phonePlaceholder: 'Preencha seu celular',
      documentPlaceholder: 'Preencha para emitir sua nota fiscal',
      fullNameSample: 'Nome do comprador',
      email: 'Email',
      emailSample: 'email@email.com',
      confirmEmail: 'Confirme seu email',
      phone: 'Celular',
      phoneSample: '(99) 99999-9999',
      document: 'CPF/CNPJ',
      documentSample: '304.761.160-23',
      documentHelp:
        'Pedimos seu documento para emissão de nota fiscal. Seus dados são criptografados e seguros.',
      offer: 'Oferta',
      installmentsLine: '{{count}}x de {{value}}',
      cashLine: '{{value}} à vista',
      paymentTitle: 'Forma de Pagamento',
      cardNumber: 'Número do cartão',
      cardNumberPlaceholder: '0000 0000 0000 0000',
      expiration: 'Vencimento',
      expirationPlaceholder: 'MM/AA',
      cvv: 'CVV',
      cvvPlaceholder: '000',
      cardNumberSample: '5125 1456 5641 4010',
      expirationSample: '10/25',
      cvvSample: '123',
      expressPayWith: 'Pagar com',
      expressDivider: 'OU',
      newBadge: 'NOVO',
      pagaleveTab: 'PIX 4x sem juros',
      pagaleveTitle: 'Parcele no pix sem cartão',
      pagaleveDescription: 'Com a Pagaleve você parcela no Pix sem precisar de cartão de crédito ou limite bancário.',
      pagaleveHint: 'Sua compra já está pré-aprovada! Para concluir, basta clicar em Pagar com Parcelamento no Pix',
      pagaleveToday: 'Hoje',
      pagaleveDays: '{{days}} dias',
      installments: 'Parcelas',
      subscription: 'Assinatura',
      boletoNotice: 'Boletos podem levar até 3 dias úteis para serem efetivados após o pagamento.',
      addBump: 'Adicionar produto!',
      removeBump: 'Remover produto',
      summaryTitle: 'Resumo do pedido',
      couponPlaceholder: 'Código de desconto',
      applyCoupon: 'Aplicar Cupom',
      removeCoupon: 'Remover Cupom',
      invalidCoupon: 'Cupom inválido',
      couponApplied: 'Cupom aplicado ({{percent}}%)',
      singlePayment: 'Pagamento único',
      total: 'Total',
      payNow: 'Pagar agora',
      payWith: 'Pagar com {{method}}',
      generatePix: 'Gerar PIX',
      securePurchase: 'Compra segura',
      termsIntro: 'Ao prosseguir, você concorda com os',
      termsOfUse: 'Termos de uso',
      termsOf: 'de',
      termsSeller: 'o vendedor',
      termsAnd: ', além dos',
      terms: 'Termos',
      termsAndPolicies: 'e',
      policies: 'Políticas',
      termsCakto: 'da Cakto.',
      processedBy: 'Processado por Cakto',
      morStatement: 'A Cakto Commerce OÜ é a comerciante oficial (Merchant of Record) e a responsável por esta compra.',
      registryCode: 'Código de registro',
      country: 'País',
      entityCountry: 'Estônia',
      contact: 'Contato',
      agreeWithTerms: 'Ao continuar, você concorda com os',
      purchaseTerms: 'Termos de Compra',
      privacyPolicyJoiner: 'e a',
      privacyPolicy: 'Política de Privacidade',
      recaptchaNotice: 'Este site é protegido pelo reCAPTCHA do Google',
      installmentWithInterest: '* O valor parcelado possui acréscimo.',
    },
    paymentMethods: {
      pix: `PIX`,
      pix_auto: `PIX Automático`,
      boleto: `Boleto`,
      credit_card: `Cartão de Crédito`,
      picpay: `PicPay`,
      applepay: `ApplePay`,
      googlepay: `GooglePay`,
      openfinance_nubank: `Nubank`,
      paypal_wallet: `PayPal`,
      mercadopago_wallet: `Mercado Pago`,
      pagaleve: `Parcelamento no Pix`,
      threeDs: `3DS`,
      debit_card: `Cartão de Débito`,
      oxxo: `OXXO`,
      spei: `SPEI`,
      pse: `PSE`,
      nequi: `Nequi`,
      safetypay: `SafetyPay`,
      rapipago: `Rapipago`,
      pagofacil: `Pago Fácil`,
    },
    payButton: {
      label: `Pagar com`,
    },
    orderSummary: {
      title: `Resumo do pedido`,
      couponPlaceholder: `Código de desconto`,
      removeCoupon: `Remover cupom`,
      applyCoupon: `Aplicar cupom`,
      couponApplied: `Cupom aplicado`,
      total: `Total`,
      invalidCoupon: `Cupom inválido`,
    },
    orderBumps: {
      limitedOffer: `Oferta limitada`,
      limitedOffers: `Ofertas limitadas`,
      selected: `Selecionado`,
      subscription: `Assinatura`,
      installments: `Parcelas`,
      addProduct: `Adicionar Produto`,
    },
    productDescription: {
      connector: `ou`,
      upfront: `à vista`,
    },
    productPurchase: {
      securePurchase: `Compra segura`,
      needHelp: `Precisa de ajuda?`,
      sellerContact: `Veja o contato do vendedor`,
      total: `Total`,
      connector: `ou`,
      termsConnector: `e`,
      processing: `Cakto está processando este pagamento para o vendedor`,
      captcha: `Este site é protegido pelo reCAPTCHA do Google`,
      privacyPolicy: `Política de privacidade`,
      termsOfService: `Termos de serviço`,
      installments: `* Parcelamento com acréscimo`,
      purchaseTermsIntro: `Ao continuar, você concorda com os`,
      purchaseTerms: `Termos de Compra`,
      currentRenewal: `Renovação atual`,
      upfront: `à vista`,
    },
    paymentDetails: {
      cardNumber: `Número do cartão`,
      expiration: `Vencimento`,
      subscription: `Assinatura`,
      installments: `Parcelas`,
      saveCard: `Salvar dados para as próximas compras`,
      security: `Os seus dados de pagamento são criptografados e processados de forma segura.`,
    },
    pix: {
      instantRelease: `Liberação imediata`,
      bankApp: `É simples, só usar o aplicativo de seu banco para pagar Pix`,
    },
    boleto: {
      message: `Boletos podem levar 3 dias úteis para serem efetivados após o pagamento.`,
    },
    threeDs: {
      security: `Segurança adicional com autenticação 3D Secure`,
      fraud: `Proteção contra fraudes em transações online`,
      approval: `Aprovação mais rápida e confiável`,
    },
    preview: {
      yourDetails: `Seus dados`,
      fullName: `Nome completo`,
      buyerName: `Nome do comprador`,
      confirmEmail: `Confirme seu e-mail`,
      phone: `Celular`,
      payment: `Pagamento`,
      processingTooltip: `Enviar e-mail para {{email}}`,
      processing: `Cakto está processando este pagamento para o vendedor`,
      securePurchase: `Compra 100% segura`,
      captcha: `Este site é protegido pelo reCAPTCHA do Google`,
      privacyPolicy: `Política de privacidade`,
      termsOfService: `Termos de serviço`,
      termsConnector: `e`,
      installments: `* Parcelamento com acréscimo`,
      purchaseTermsIntro: `Ao continuar, você concorda com os`,
      purchaseTerms: `Termos de Compra`,
      phoneSample: `+55 (99) 99999-9999`,
      phoneFlagAlt: `Bandeira do Brasil`,
    },
    price: {
      singleInstallment: `1 x de {{value}}`,
    },
    recurrence: {
      renewal: `Renovação {{period}}`,
      units: {
        day: `dia`,
        week: `semana`,
        month: `mês`,
        bimonth: `bimestre`,
        quarter: `trimestre`,
        semester: `semestre`,
        year: `ano`,
      },
      labels: {
        daily: `diário`,
        weekly: `semanal`,
        monthly: `mensal`,
        bimonthly: `bimestral`,
        quarterly: `trimestral`,
        semiannual: `semestral`,
        annual: `anual`,
      },
    },
  },
  contactPage: {
    pageTitle: {
      area: `Páginas`,
      screen: `Contato`,
    },
    hero: {
      title: {
        where: `Onde`,
        to: `nos`,
        find: `encontrar`,
        us: `?`,
      },
    },
    form: {
      titleLine1: `Fique à vontade para entrar em contato.`,
      titleLine2: `Vamos ficar felizes em ouvir você.`,
      name: `Nome`,
      email: `Email`,
      subject: `Assunto`,
      message: `Digite sua mensagem aqui.`,
      submit: `Enviar agora`,
    },
    map: {
      address: `Endereço`,
    },
  },
};

export default ptBr;
